import { useTranslation } from "react-i18next";

/**
 * Fullscreen fallback when the app runs in an iframe on a route outside the embed allowlist.
 * Copy is i18n-driven so locales can override `iframe.access_denied`.
 */
const IframeAccessDenied = () => {
	const { t } = useTranslation();

	return (
		<div className="min-vh-100 d-flex align-items-center justify-content-center bg-light px-3">
			<p className="text-center mb-0 h5 text-secondary">{t("iframe.access_denied")}</p>
		</div>
	);
};

export default IframeAccessDenied;
